import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteConference = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (conferenceId: string) =>
      await request(`${sport}/o/${organizationId}/conferences/${conferenceId}`, {
        method: "DELETE",
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["conferences", sport, organizationId] });
    },
  });
};
